import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-059eb110"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "score"
}
const _hoisted_2 = { class: "title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_4 = {
  key: 0,
  class: "score"
}
const _hoisted_5 = {
  key: 1,
  class: "score-detail"
}
const _hoisted_6 = {
  key: 2,
  class: "review"
}
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "review-wrapper" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.lineSurvey?.questions, (question) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "evaluation-wrapper",
        key: question.order
      }, [
        (question.answerType === 'radio' && question.datasource)
          ? (_openBlock(), _createBlock($setup["BaseSelect"], {
              key: 0,
              label: question.title,
              name: "evaluationLine",
              datasource: question.datasource,
              itemValue: question.valueField,
              itemText: "turnFullName",
              lineSurveyId: $props.lineSurvey!.id,
              value: $setup.selectedTurnId,
              onOnChangeSelect: $setup.onChangeSelectLine,
              onOnReceivedEmptyTargetLines: $setup.emitOnReceivedEmptyTargetLines
            }, null, 8 /* PROPS */, ["label", "datasource", "itemValue", "lineSurveyId", "value"]))
          : _createCommentVNode("v-if", true),
        (question.answerType === 'radio' && question?.answers)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("p", _hoisted_2, [
                _createTextVNode(" 통근버스와 함께한 출근길,"),
                _hoisted_3,
                _createTextVNode(_toDisplayString(question.title), 1 /* TEXT */)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.answers, (answer) => {
                return (_openBlock(), _createBlock($setup["InlineSvg"], {
                  key: answer.order,
                  class: _normalizeClass({
                active: $setup.selectedScore === answer.order,
              }),
                  src: $setup.moodIconList[answer.order - 1]?.src,
                  onClick: ($event: any) => (
                $setup.onClickMoodIcon(question.answerType, answer.id, question.order)
              )
                }, null, 8 /* PROPS */, ["class", "src", "onClick"]))
              }), 128 /* KEYED_FRAGMENT */)),
              ($setup.selectedScore === 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_4, "선택하세요"))
                : (_openBlock(), _createElementBlock("p", _hoisted_5, [
                    _createElementVNode("strong", null, _toDisplayString($setup.selectedScore) + "점", 1 /* TEXT */),
                    _createTextVNode(" " + _toDisplayString(`(${$setup.moodIconList[$setup.selectedScore - 1].detail})`), 1 /* TEXT */)
                  ]))
            ]))
          : _createCommentVNode("v-if", true),
        (question.answerType === 'optionMulti')
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("p", _hoisted_7, _toDisplayString(question.title), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.answers, (answer) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: answer.order,
                    class: _normalizeClass({ active: $setup.isSelectedReview(answer.id) }),
                    tyle: "button",
                    onClick: ($event: any) => (
                  $setup.onClickReview(question.answerType, answer.id, question.order)
                )
                  }, _toDisplayString(answer.title), 11 /* TEXT, CLASS, PROPS */, _hoisted_9))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ]))
          : _createCommentVNode("v-if", true),
        (question.answerType === 'text')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createElementVNode("p", _hoisted_10, _toDisplayString(question.title), 1 /* TEXT */),
              _createVNode($setup["BaseTextarea"], {
                class: "text-area-container",
                id: "textarea",
                cols: 30,
                rows: 6,
                maxlength: 300,
                placeholder: question.placeholder,
                value: $setup.opinion,
                getTextAreaLength: $setup.opinion.length,
                onOnInput: ($event: any) => (
            $setup.onInputTextarea(question.answerType, $event, question.order)
          )
              }, null, 8 /* PROPS */, ["placeholder", "value", "getTextAreaLength", "onOnInput"])
            ], 64 /* STABLE_FRAGMENT */))
          : _createCommentVNode("v-if", true)
      ]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}